import { Pipe, PipeTransform } from '@angular/core';
import * as hljs from 'highlight.js';

@Pipe({
  name: 'highlightCode'
})
export class HighlightCodePipe implements PipeTransform {

  transform(str: string, lang = 'html'): string {
    return this.highlight(str, lang);
  }

  private highlight(str: string, lang: string): string {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(lang, str).value;
      } catch { }
    }

    try {
      return hljs.highlightAuto(str).value;
    } catch { }

    return ''; // use external default escaping
  }

}
